import request from "@/utils/request";
import { GoogleBindForm, LoginApiResult, LoginData } from "./types";

/**
 * 登录API
 *
 * 未绑定谷歌验证码时后端返回 code=G0001，data 为二维码绑定信息(googleToken/googleSecretQr)
 * 注意：响应拦截器放行后 resolve 的是响应体 { code, data, msg }
 *
 * @param data {LoginData}
 * @returns
 */
export function loginApi(data: LoginData): Promise<LoginApiResult> {
  const formData = {
    username: data.username,
    password: data.password,
    googleCode: data.googleCode ?? "",
    // grant_type: "password",
  };
  // formData.append("username", data.username);
  // formData.append("password", data.password);
  // formData.append("grant_type", "password");
  return request({
    url: "/api/admin/login",
    method: "post",
    data: formData,
  }) as Promise<LoginApiResult>;
}

/**
 * 用户绑定激活谷歌验证码API
 *
 * 绑定成功即返回登录结果(accessToken等)
 *
 * @param data {GoogleBindForm}
 * @returns
 */
export function bindGoogleAutApi(
  data: GoogleBindForm
): Promise<LoginApiResult> {
  return request({
    url: "/api/admin/bind/googleAut",
    method: "post",
    data,
  }) as Promise<LoginApiResult>;
}

/**
 * 注销API
 */
export function logoutApi() {
  return request({
    url: "/api/v1/users/logout",
    method: "delete",
  });
}
